import account from './account'
import branding from './branding'
import cities from './cities'
import couriers from './couriers'
import dashboard from './dashboard'
import fileManager from './fileManager'
import forms from './forms'
import inventories from './inventories'
import nav from './nav'
import provinces from './provinces'
import shared from './shared'
import transports from './transports'
import stocks from './stocks'

export default {
  direction: 'ltr',
  account,
  branding,
  cities,
  couriers,
  dashboard,
  fileManager,
  forms,
  inventories,
  nav,
  provinces,
  shared,
  transports,
  stocks
}
